<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form-model @keydown.enter.native="searchQuery" @submit.native.prevent layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-model-item label="供水流域">
              <j-dict-select-tag @change="searchQuery" dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择供水流域" v-model="queryParam.devProcessId" />
            </a-form-model-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="类型">
              <j-multi-select-tag :options="visibleOptions" @change="searchQuery" type="checkbox"
                v-model="queryParam.mapVisible" />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-model-item label="设备名称">
              <a-input placeholder="请输入设备名称" v-debounce="searchQuery" v-model="queryParam.devName"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" @keyup.enter.native="searchQuery" icon="search"
                type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form-model>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="batchSetVisible()" icon="check-circle" type="primary">批量设置可见</a-button>
      <a-button @click="batchClearVisible()" icon="close-circle" type="primary">批量取消可见</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table :columns="columns" :customRow="customRowRender" :dataSource="dataSource" :loading="loading"
        :pagination="ipagination" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }" @change="handleTableChange" bordered class="j-table-force-nowrap" ref="table" rowKey="id"
        size="middle">
        <span slot="mapVisibleSlot" slot-scope="text, record">
          <a-switch :checked="Number(text) === 1" @change="(checked) => handleToggleVisible(checked, record)" />
        </span>

        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>

        <template slot="waterStatisticsSlot" slot-scope="text">
          <div v-if="text" style="text-align: left;">
            <div>最近30天: 【{{ text.last30DaysCount }}次】 / 【{{ formatVolume(text.last30DaysVolume) }}吨】</div>
            <div>最近半年: 【{{ text.last6MonthsCount }}次】 / 【{{ formatVolume(text.last6MonthsVolume) }}吨】</div>
          </div>
          <div v-else>-</div>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction, postAction, putAction } from '../../../../api/manage'
import { DragTableMixin } from '@/mixins/DragTableMixin'
import { httpAction } from '@/api/manage'
import JTreeSelectDevice from '@/components/jeecg/JTreeSelectDevice'
import Area from '@/components/_util/Area'
export default {
  name: 'DevMapVisible',
  mixins: [DragTableMixin, JeecgListMixin, mixinDevice],
  components: {
    JTreeSelectDevice
  },
  data() {
    return {
      description: '设备地图可见性设置页面',
      visibleOptions: [
        { label: '可见', value: '1' },
        { label: '不可见', value: '0' }
      ],
      // 表头
      columns: [
        {
          title: '区域',
          align: 'center',
          dataIndex: 'region',
          sorter: true,
          scopedSlots: { customRender: 'pcaSlot' }
        },
        {
          title: '设备名称',
          align: 'center',
          dataIndex: 'devName',
          sorter: true
        },

        {
          title: '表号',
          align: 'center',
          dataIndex: 'devTag',
          sorter: true
        },
        {
          title: '加水统计',
          align: 'center',
          dataIndex: 'waterStatistics',
          width: 200,
          scopedSlots: { customRender: 'waterStatisticsSlot' },
          sorter: (a, b) => {
            const aCount = a.waterStatistics?.last30DaysCount || 0
            const bCount = b.waterStatistics?.last30DaysCount || 0
            return aCount - bCount
          }
        },
        {
          title: '安装位置',
          align: 'left',
          dataIndex: 'location',
          scopedSlots: { customRender: 'locationSlot' },
          sorter: true
        },

        {
          title: '设备型号',
          align: 'center',
          dataIndex: 'devTypeId_dictText',
          sorter: true
        },
        {
          title: '地图可见',
          align: 'center',
          dataIndex: 'mapVisible',
          width: 100,
          sorter: true,
          scopedSlots: { customRender: 'mapVisibleSlot' }
        }
      ],
      isorter: {
        column: 'sort',
        order: 'asc'
      },
      queryParam: {
        includeStatistics: true,
        devName: '',
        devClassCode: '',
        devTypeId: '',
        devProcessId: ''
      },
      url: {
        list: '/device/devList/origin-list-with-statistics',
        editBatch: '/device/devList/editBatch',
      },
      listPagination: {
        pageSize: 50,
        pageSizeOptions: ['50', '100', '200', '300']
      },
      devModelList: [],
      pcaData: ''
    }
  },
  created() {
    this.pcaData = new Area()
    this.getSuperFieldList()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    initDictConfig() { },
    getSuperFieldList() {
      let fieldList = []
      this.superFieldList = fieldList
    },

    // 批量设置可见
    batchSetVisible() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择至少一个设备')
        return
      }
      const that = this
      this.$confirm({
        title: '确认操作',
        content: `确定要设置 ${this.selectedRowKeys.length} 个设备为可见吗？`,
        onOk() {
          const devs = that.selectedRowKeys.map(id => ({ id, mapVisible: 1 }))
          putAction(that.url.editBatch, devs).then(res => {
            if (res.success) {
              that.$message.success('设置成功')
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.error(res.message || '设置失败')
            }
          })
        }
      })
    },

    // 批量取消可见
    batchClearVisible() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择至少一个设备')
        return
      }
      const that = this
      this.$confirm({
        title: '确认操作',
        content: `确定要取消 ${this.selectedRowKeys.length} 个设备的可见性吗？`,
        onOk() {
          const devs = that.selectedRowKeys.map(id => ({ id, mapVisible: 0 }))
          putAction(that.url.editBatch, devs).then(res => {
            if (res.success) {
              that.$message.success('设置成功')
              that.loadData()
              that.onClearSelected()
            } else {
              that.$message.error(res.message || '设置失败')
            }
          })
        }
      })
    },
    // 切换单个设备可见性
    handleToggleVisible(checked, record) {
      const dev = {
        id: record.id,
        mapVisible: checked ? 1 : 0
      }
      putAction(this.url.editBatch, [dev]).then(res => {
        if (res.success) {
          this.$message.success(checked ? '已设置为可见' : '已取消可见');
          record.mapVisible = checked ? 1 : 0;
        } else {
          this.$message.error(res.message || '操作失败');
        }
      }).catch(() => {
        this.$message.error('操作失败');
      });
    },
    getPcaText(code) {
      return this.pcaData.getText(code);
    },
    formatVolume(volume) {
      return volume ? volume.toFixed(3) : '0.000';
    },
    // 重写 handleTableChange，waterStatistics 字段排序走前端
    handleTableChange(pagination, filters, sorter) {
      // 如果是 waterStatistics 字段排序，不走后端
      if (sorter.field === 'waterStatistics') {
        this.ipagination = pagination
        return
      }
      // 其他字段排序走后端，调用父类方法
      return JeecgListMixin.methods.handleTableChange.call(this, pagination, filters, sorter)
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
